import { render, staticRenderFns } from "./Graphics.vue?vue&type=template&id=1bfef7fe&scoped=true&"
import script from "./Graphics.vue?vue&type=script&lang=js&"
export * from "./Graphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfef7fe",
  null
  
)

export default component.exports